import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'
import RavenPlugin from './plugins/raven'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import Amplify from 'aws-amplify'
import config from './auth_config.json'
import mpAccessControlPlugin from './directives/mp-access-group'
import Megaload from './components/megaload/megaload.vue'
import { environmentSwitch, setAppUrls } from './environment'
import { VBHoverPlugin, VBTooltipPlugin } from 'bootstrap-vue'
import { MegaUI } from '@megaport/mega-ui'

import 'element-ui/lib/theme-chalk/index.css'
import './assets/styles/theme-variables.scss'
import './assets/styles/base'
import svgSpriteRaw from '@/assets/svg-icons.svg?raw'
import './poly'
import './ui_library'

// Inject the icon sprite into the DOM and prefix IDs with `svg-icons_`
// to match the previous svg-sprite-loader behaviour.
{
  const prefixed = svgSpriteRaw.replace(/id="(icon-[^"]+)"/g, 'id="svg-icons_$1"')
  const container = document.createElement('div')
  container.style.display = 'none'
  container.innerHTML = prefixed
  document.body.insertBefore(container, document.body.firstChild)
}

Vue.use(mpAccessControlPlugin)
Vue.component('MegaLoad', Megaload)
Vue.use(MegaUI)
Vue.use(VBHoverPlugin)
Vue.use(VBTooltipPlugin)

environmentSwitch()
setAppUrls()

const oauth = {
  domain: config.OAUTH_DOMAIN,
  scope: ['email', 'profile', 'openid'],
  redirectSignIn: `${window.location.origin}/${config.SIGNIN_CALLBACK}`,
  redirectSignOut: `${window.location.origin}/${config.SIGNOUT_CALLBACK}`,
  responseType: 'code',
}

export const awsConfig = {
  Analytics: {
    disabled: true,
  },
  Auth: {
    oauth: oauth,
    region: config.REGION,
    identityPoolId: config.IDENTITY_POOL_ID,
    userPoolId: config.USER_POOL_ID,
    userPoolWebClientId: config.CLIENT_ID,
  },
}

Amplify.configure(awsConfig)

import {
  Tooltip,
  Table,
  TableColumn,
  Input,
  Button,
  Switch,
  Col,
  Row,
  ButtonGroup,
  Form,
  FormItem,
  Notification,
  Checkbox,
  Select,
  Option,
  DatePicker,
  TimePicker,
  TimeSelect,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Tabs,
  TabPane,
  Dialog,
  Card,
  Menu,
  MenuItem,
  Popover,
  Loading,
  Spinner,
} from 'element-ui'

Vue.config.productionTip = import.meta.env.PROD

// UI Components

locale.use(lang)
Vue.use(Tooltip)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Input)
Vue.use(Col)
Vue.use(Row)
Vue.use(Button)
Vue.use(Switch)
Vue.use(ButtonGroup)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Checkbox)
Vue.use(Select)
Vue.use(Option)
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(TimeSelect)
Vue.use(Dropdown)
Vue.use(DropdownItem)
Vue.use(DropdownMenu)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Dialog)
Vue.use(Card)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Popover)
Vue.use(Loading.directive)
Vue.use(Spinner)

Vue.prototype.$notify = Notification
Vue.prototype.$salesforceUrl = window.salesforceUrl
Vue.prototype.$adminPortalUrl = window.adminPortalUrl
Vue.prototype.$cmaUrl = window.cmaUrl
Vue.prototype.$portalUrl = window.portalUrl
Vue.prototype.$graphUrl = window.graphUrl

// Plugins
Vue.use(RavenPlugin, {
  url: 'https://515e95dfb5a44803b5df9d0d7df3523c@sentry-web.megaport.com/39',
  ignoreErrors: ['Unauthorized', 'ResizeObserver loop limit exceeded', 'Error: ResizeObserver loop limit exceeded'],
})

// Vue
new Vue({
  router,
  store,
  beforeCreate: async () => {
    try {
      await store.dispatch('user/getMyUserDetails', { root: true })
      // Marketing: tag internal staff so GA can exclude them (readable on *.megaport.com).
      document.cookie = 'megaport_internal=true; max-age=34560000; path=/; domain=.megaport.com; Secure; SameSite=Lax'
    } catch (error) {
      if (import.meta.env.PROD) {
        window.location.href = '/auth/authenticate'
      } else {
        const message = `[${error.status} ${error.statusText}] Could not load user credentials. Please refresh your token by logging into the target environment`
        alert(message)
      }
    }
  },
  render: h => h(App),
}).$mount('#app')

// Initialize theme system
store.dispatch('theme/initializeTheme')
